"use client";
import React from "react";
import Link from "next/link";
import { cn } from "~/utils/fontsConfig";
import { usePathname } from "next/navigation";
import { useEventContext } from "~/app/providers";

type BreadCrumb = {
    name: string;
    href: string;
};

const Breadcrumbs = () => {
    const { event } = useEventContext();
    const pathname = usePathname();
    const breadCrumbs: BreadCrumb[] = [];

    if (pathname?.includes("events") || pathname?.includes("eventId")) {
        if (event?.community?.name) {
            breadCrumbs.push({
                name: event.community.name,
                href: `/beta/${event.community.slug}`, // assuming community has a slug
            });
        }

        if (event?.slug) {
            breadCrumbs.push({
                name: event.name,
                href: `/events/${event.slug}`,
            });
        }

        const otherRoutes = {
            settings: {
                name: "Event Settings",
                href: `/events/${event?.slug}/settings`,
            },
            "digital-badge": {
                name: "Digital Badge",
                href: `/events/${event?.slug}/digital-badge`,
            },
            duplicate: {
                name: "Duplicate Event",
                href: `/events/${event?.slug}/duplicate`,
            },
            attendees: {
                name: "Attendees",
                href: `/events/${event?.slug}/attendees`,
            },
            hosts: {
                name: "Hosts",
                href: `/events/${event?.slug}/hosts`,
            },
            "auto-reminders": {
                name: "Auto Reminders",
                href: `/events/${event?.slug}/auto-reminders`,
            },
            "send-messages": {
                name: "Send Messages",
                href: `/events/${event?.slug}/send-messages`,
            },
            checkin: {
                name: "Checkin",
                href: `/events/${event?.id}/checkin`,
            },
            promotion: {
                name: "Promotion",
                href: `/events/${event?.slug}/promotion`,
            },
        };

        for (const [key, value] of Object.entries(otherRoutes)) {
            if (pathname?.includes(key)) {
                breadCrumbs.push(value);
            }
        }
    }

    if (pathname?.includes("notifications")) {
        breadCrumbs.push({
            name: "Notifications",
            href: "/notifications",
        });
    }

    return (
        <p className="text-md ml-1 mr-2 line-clamp-1 font-normal">
            {breadCrumbs.map((crumb, index) => (
                <span key={index}>
                    <Link href={crumb.href}>
                        <span
                            className={cn(
                                "min-w-[1px] cursor-pointer break-words hover:text-v3-primary hover:underline",
                                index === breadCrumbs.length - 1 &&
                                    "text-white",
                                index < breadCrumbs.length - 1 &&
                                    "text-v3-N-300",
                            )}
                        >
                            {crumb.name}
                        </span>
                    </Link>
                    {index < breadCrumbs.length - 1 && " > "}
                </span>
            ))}
        </p>
    );
};

export default Breadcrumbs;
